const BADGE_ID = 'stripe-climate-footer-badge';
const BADGE_SRC = 'https://climate.stripe.com/badge/5LXVuZ?theme=dark&size=large&locale=en-GB';

function installStripeClimateBadge() {
  const footer = document.querySelector('footer');
  if (!footer || document.getElementById(BADGE_ID)) return;
  const container = document.createElement('div');
  container.id = BADGE_ID;
  container.setAttribute('aria-label', 'Stripe Climate commitment');
  container.style.cssText = 'width:min(100% - 32px,1424px);display:flex;justify-content:center;align-items:center;margin:28px auto 0;padding:24px 0 8px;border-top:1px solid rgba(148,163,184,.28);clear:both;grid-column:1/-1;box-sizing:border-box;overflow:hidden;';
  container.innerHTML = `<iframe width="380" height="82" style="border:0;max-width:100%;" src="${BADGE_SRC}" title="Stripe Climate commitment" loading="lazy"></iframe>`;
  footer.appendChild(container);
}

const observer = new MutationObserver(installStripeClimateBadge);
function startStripeClimateBadge() {
  installStripeClimateBadge();
  observer.observe(document.documentElement, { childList: true, subtree: true });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startStripeClimateBadge, { once: true });
else startStripeClimateBadge();

export {};
